import { format } from "date-fns";
import { Image, Table } from "react-bootstrap";

import avatarImage from "../../assets/images/avatar.svg";

const mediaOrigin =
  process.env.NODE_ENV === "production" ? "" : process.env.REACT_APP_BACKEND_URL || "";

function NotesModalHistory({ data = [], module }) {
  return (
    <div className="table-responsive table--no-card treatment-notes-history">
      <Table className="table table-borderless table-striped table-earning mb-0">
        <thead>
          <tr>
            <th className="INS-width-1px" />
            <th>Date</th>
            <th>Time</th>
            <th className="td-autosize">User</th>
            <th>Note</th>
            <th>Category</th>
          </tr>
        </thead>
        <tbody>
          {data.length ? (
            data.map((note, index) => {
              const profile = note.created_by?.bp_attorneystaff_userprofile;
              const profilePicture = profile?.profile_pic_29p || profile?.profile_pic_19p;
              const createdAt = note.created_at ? new Date(note.created_at) : null;
              const validDate = createdAt && !Number.isNaN(createdAt.getTime());

              return (
                <tr className={`${note.entity_type}${note.record_id}`} key={note.id}>
                  <td className="td-autosize width-36">{index + 1}</td>
                  <td className="td-autosize">
                    {validDate ? format(createdAt, "MMMM dd, yyyy") : ""}
                  </td>
                  <td className="td-autosize">{validDate ? format(createdAt, "h:mm a") : ""}</td>
                  <td className="td-autosize">
                    <span className="d-flex align-items-center text-nowrap">
                      <span className="ic ic-avatar ic-29 has-avatar-icon has-cover-img">
                        <Image
                          src={profilePicture ? mediaOrigin + profilePicture : avatarImage}
                          alt=""
                        />
                      </span>
                      <span className="ms-2 text-black">
                        {note.created_by?.first_name} {note.created_by?.last_name}
                      </span>
                    </span>
                  </td>
                  <td className="client_page_note_row INS-color-black">{note.description}</td>
                  <td className="td-autosize">{note.category?.name || module}</td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan={6} className="text-center">
                No data available
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </div>
  );
}

export default NotesModalHistory;
